const Constants = {
  //apiURL: 'http://localhost:3000/local',
  apiURL: 'https://32yq0hrsr6.execute-api.ap-southeast-2.amazonaws.com/Stage', //[dev]
  //apiURL: 'https://xl1990ss94.execute-api.ap-southeast-2.amazonaws.com/Prod', //[prod]
  usersURL: '/users',
  rolesURL: '/users/roles',
  contractorsURL: '/contractor',
  customersURL: '/customer',
  termsURL: '/standardterm',
  adhocTermsURL: '/adhocterm',
  tendersURL: '/tender',
  resourcesURL: '/resource',
  mediaURL: '/media',
  billableURL: '/billable',
  projectsURL: '/projecttemplate',
  projectDashboardsURL: '/project',
  companyProfileURL: '/company',
  fetchQuoteCompanyProfile: '/company/fetchQuoteCompanyProfile',
  refBundleURL: '/refbundle',
  quoteURL: '/quote',
  warehousesURL: '/warehouse',
  criticalcheckURL: '/criticalcheck',
  mobileAssetsURL: '/mobileasset',
  documentPDFsURL: '/pdf',
  labourURL: '/labour',
  documentURL: '/document',
  photoURL: '/photo',
  documentMediaURL: '/documentmedia',
  crewsURL: '/crew',
  shiftURL: '/shift',
  dailyinfoURL: '/dailyinfo',
  userSignatureURL: '/usersignature',
  inventoryURL: '/inventory',

  swmsURL: '/swms',
  // GOOGLE_API_KEY: 'AIzaSyAl-7vUQMgnDIVPHoB1TYqEj_9J4qqKa6w',
  GOOGLE_API_KEY: 'AIzaSyBiJqKUSQPQ4x5oW2x4d_TAiW59tXbEVjc',
  USER_POOL_REGION: 'ap-southeast-2',
  REFRESH_TOKEN_URL: `/cognito/refresh-token`,
  CLIENTID: '46uirin7kc5aemb54upaq5h76o', //[dev]
  //CLIENTID: '59g89egoi3scotdupbl4g2j36g', //[Prod]
  DEFAULT_PAGE_SIZE: 25,
  COMMON_SERVER_ERROR: 'Process Failed',
  PHOTO_CDN_URL: 'https://dfnrlfl8hu3bm.cloudfront.net', //Dev
  // PHOTO_CDN_URL: '  https://d2gae951uyj6n6.cloudfront.net', //Prod

  COGNITO_DOMAIN:
    'https://ap-southeast-2asddmxidd.auth.ap-southeast-2.amazoncognito.com', //[dev]

  //'https://ap-southeast-2evwpgssya.auth.ap-southeast-2.amazoncognito.com', // [prod]
};

export default Constants;
